// @ts-nocheck
(function () {
  'use strict';

  var STORAGE_KEY = 'attribution_data';
  var DEBUG_KEY = 'attribution_debug';
  var SUPPORTED_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'utm_agent',
    'gclid',
    'fbclid',
    'msclkid',
    'ttclid',
    'dclid',
    'ref',
    'affiliate',
    'c',
    'oid2',
    'affid2',
    'sub1',
    'sub2',
  ];

  function safeJsonParse(value, fallbackValue) {
    if (!value) return fallbackValue;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallbackValue;
    }
  }

  function safeStorageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function getCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function getEftidFromCookie() {
    try {
      var cookies = document.cookie.split(';');
      var lastValue = '';
      for (var i = 0; i < cookies.length; i++) {
        var pair = cookies[i].trim();
        if (pair.indexOf('ef_tid_') === 0) {
          var eqIndex = pair.indexOf('=');
          if (eqIndex !== -1) {
            var val = decodeURIComponent(pair.substring(eqIndex + 1));
            if (val) lastValue = val;
          }
        }
      }
      return lastValue;
    } catch (error) {
      return '';
    }
  }

  var EVERFLOW_ADVERTISER_ID =
    (window.AquaTruIntegrations && window.AquaTruIntegrations.everflowAdvertiserId) || 2;
  var _eftidResolved = false;

  function getEftidFromSdk() {
    if (window.EF && typeof window.EF.getAdvertiserTransactionId === 'function') {
      try {
        var tid = window.EF.getAdvertiserTransactionId(EVERFLOW_ADVERTISER_ID);
        if (tid) return String(tid);
      } catch (e) {
        // SDK not ready yet
      }
    }
    return '';
  }

  function resolveEftid() {
    var tid = getEftidFromSdk() || getEftidFromCookie();
    if (!tid) {
      var stored = getStoredAttribution();
      if (stored.eftid) tid = stored.eftid;
    }
    return tid || '';
  }

  function isDebugEnabled() {
    return safeStorageGet(DEBUG_KEY) === '1';
  }

  function logDebug() {
    if (!isDebugEnabled()) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[Attribution]');
    console.log.apply(console, args);
  }

  function getStoredAttribution() {
    var raw = safeStorageGet(STORAGE_KEY);
    var parsed = safeJsonParse(raw, null);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {};
    }
    return parsed;
  }

  function setStoredAttribution(data) {
    return safeStorageSet(STORAGE_KEY, JSON.stringify(data));
  }

  function extractSupportedParams(searchParams) {
    var result = {};
    for (var i = 0; i < SUPPORTED_PARAMS.length; i++) {
      var key = SUPPORTED_PARAMS[i];
      var value = searchParams.get(key);
      if (value) result[key] = value;
    }
    return result;
  }

  function normalizeEverflowParams(urlObject) {
    var params = urlObject.searchParams;
    var oid2 = params.get('oid2');
    var affid2 = params.get('affid2');

    if (!oid2 || !affid2) return false;

    var modified = false;
    if (!params.get('utm_source')) {
      params.set('utm_source', 'everflow');
      modified = true;
    }
    if (!params.get('utm_medium')) {
      params.set('utm_medium', 'influencers');
      modified = true;
    }
    if (!params.get('utm_campaign')) {
      params.set('utm_campaign', affid2);
      modified = true;
    }
    if (!params.get('utm_id')) {
      params.set('utm_id', affid2);
      modified = true;
    }

    return modified;
  }

  function captureFromCurrentUrl() {
    var urlObject = new URL(window.location.href);
    var incoming = extractSupportedParams(urlObject.searchParams);
    var urlModified = normalizeEverflowParams(urlObject);
    if (urlModified) {
      window.history.replaceState({}, '', urlObject.toString());
    }

    var normalizedIncoming = extractSupportedParams(urlObject.searchParams);
    var normalizedKey;
    for (normalizedKey in normalizedIncoming) {
      if (Object.prototype.hasOwnProperty.call(normalizedIncoming, normalizedKey)) {
        incoming[normalizedKey] = normalizedIncoming[normalizedKey];
      }
    }

    var hasIncoming = Object.keys(incoming).length > 0;
    var stored = getStoredAttribution();
    var merged = {};
    var key;

    for (key in stored) {
      if (Object.prototype.hasOwnProperty.call(stored, key)) {
        merged[key] = stored[key];
      }
    }
    for (key in incoming) {
      if (Object.prototype.hasOwnProperty.call(incoming, key)) {
        merged[key] = incoming[key];
      }
    }

    if (hasIncoming || !merged.landing_page) {
      merged.landing_page = urlObject.pathname + urlObject.search;
    }
    if (hasIncoming || !merged.utm_captured_at) {
      merged.utm_captured_at = new Date().toISOString();
    }
    if (document.referrer && (hasIncoming || !merged.referrer)) {
      merged.referrer = document.referrer;
    }

    var liveEftid = resolveEftid();
    if (liveEftid) {
      merged.eftid = liveEftid;
    }

    setStoredAttribution(merged);
    logDebug('Captured attribution', merged);
    return merged;
  }

  function getAttribution() {
    return getStoredAttribution();
  }

  function buildCartAttributesPayload() {
    var source = getStoredAttribution();
    var attributes = {};

    function add(targetKey, sourceKey) {
      var value = source[sourceKey];
      if (typeof value === 'string' && value.length > 0) {
        attributes[targetKey] = value;
      }
    }

    add('utm_source', 'utm_source');
    add('utm_medium', 'utm_medium');
    add('utm_campaign', 'utm_campaign');
    add('utm_term', 'utm_term');
    add('utm_content', 'utm_content');
    add('utm_id', 'utm_id');
    add('utm_agent', 'utm_agent');
    add('gclid', 'gclid');
    add('fbclid', 'fbclid');
    add('msclkid', 'msclkid');
    add('ttclid', 'ttclid');
    add('dclid', 'dclid');
    add('eftid', 'eftid');

    var liveEftid = resolveEftid();
    if (liveEftid) {
      attributes.eftid = liveEftid;
      if (!source.eftid) {
        storeEftid(liveEftid);
      }
    }

    add('affiliate', 'affiliate');
    add('ref', 'ref');
    add('campaign_code', 'c');
    add('oid2', 'oid2');
    add('affid2', 'affid2');
    add('sub1', 'sub1');
    add('sub2', 'sub2');
    add('landing_page', 'landing_page');
    add('utm_captured_at', 'utm_captured_at');

    return attributes;
  }

  function appendMarketingParamsToUrl(inputUrl) {
    if (!inputUrl) return inputUrl;
    try {
      var urlObj = new URL(inputUrl, window.location.origin);
      var data = getStoredAttribution();
      for (var i = 0; i < SUPPORTED_PARAMS.length; i++) {
        var key = SUPPORTED_PARAMS[i];
        var value = data[key];
        if (value) urlObj.searchParams.set(key, value);
      }
      return urlObj.toString();
    } catch (error) {
      return inputUrl;
    }
  }

  function getShopifyRoot() {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      root = window.Shopify.routes.root;
    }
    if (root.charAt(0) !== '/') root = '/' + root;
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function buildThemePath(pathSegment) {
    var segment = pathSegment || '';
    if (segment.charAt(0) === '/') segment = segment.slice(1);
    return getShopifyRoot() + segment;
  }

  function getCheckoutSubmitUrl(form, trigger) {
    var triggerAction = trigger && trigger.getAttribute && trigger.getAttribute('formaction');
    var formAction = form && form.getAttribute && form.getAttribute('action');
    var absoluteFormAction = form && form.action;
    var candidate = triggerAction || formAction || absoluteFormAction || '';

    if (candidate) {
      try {
        var parsed = new URL(candidate, window.location.origin);
        if (parsed.origin === window.location.origin && /\/checkout($|\/|\?)/.test(parsed.pathname)) {
          return parsed.toString();
        }
      } catch (error) {
        return candidate;
      }
    }

    return buildThemePath('checkout');
  }

  function isEligibleCheckoutAnchor(href) {
    if (!href) return false;
    try {
      var parsed = new URL(href, window.location.origin);
      if (parsed.origin !== window.location.origin) return false;
      return /\/checkout($|\/|\?)/.test(parsed.pathname);
    } catch (error) {
      return false;
    }
  }

  function setHiddenInput(form, name, value) {
    var selector = 'input[name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function getVariantSkuFromForm(form) {
    var explicit = form.querySelector('input[name="properties[_variant_sku]"]');
    if (explicit && explicit.value) return explicit.value;

    var variantInput = form.querySelector('input[name="id"][data-sku]');
    if (variantInput && variantInput.dataset && variantInput.dataset.sku) {
      return variantInput.dataset.sku;
    }

    var variantSelect = form.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.options && variantSelect.selectedIndex > -1) {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (opt && opt.dataset && opt.dataset.sku) return opt.dataset.sku;
    }

    return '';
  }

  function getProductIdFromForm(form) {
    if (form && form.dataset && form.dataset.productId) return form.dataset.productId;
    if (form && form.getAttribute) {
      var directProductId = form.getAttribute('data-productid');
      if (directProductId) return directProductId;
    }

    var productIdInput =
      form &&
      form.querySelector &&
      form.querySelector('input[name="product-id"], input[name="product_id"], input[name="productId"]');
    if (productIdInput && productIdInput.value) {
      return productIdInput.value;
    }

    var formComponent = form && form.closest && form.closest('product-form-component');
    if (formComponent && formComponent.dataset && formComponent.dataset.productId) {
      return formComponent.dataset.productId;
    }

    var quickOrderComponent = form && form.closest && form.closest('quick-order-list-component');
    if (quickOrderComponent && quickOrderComponent.dataset && quickOrderComponent.dataset.productId) {
      return quickOrderComponent.dataset.productId;
    }

    var genericProductContainer = form && form.closest && form.closest('[data-product-id]');
    if (genericProductContainer && genericProductContainer.dataset && genericProductContainer.dataset.productId) {
      return genericProductContainer.dataset.productId;
    }

    var genericProductIdContainer = form && form.closest && form.closest('[data-productid]');
    if (genericProductIdContainer && genericProductIdContainer.getAttribute) {
      var genericProductId = genericProductIdContainer.getAttribute('data-productid');
      if (genericProductId) return genericProductId;
    }

    return '';
  }

  function getProductTypeFromForm(form) {
    if (!form) return '';

    var formType = form.getAttribute('data-product-type');
    if (formType) return String(formType).toLowerCase();

    var formComponent = form.closest && form.closest('product-form-component');
    if (formComponent && formComponent.dataset && formComponent.dataset.productType) {
      return String(formComponent.dataset.productType).toLowerCase();
    }

    var genericProductContainer = form.closest && form.closest('[data-product-type]');
    if (genericProductContainer && genericProductContainer.dataset && genericProductContainer.dataset.productType) {
      return String(genericProductContainer.dataset.productType).toLowerCase();
    }

    return '';
  }

  function isBundleProductType(value) {
    if (!value) return false;
    return String(value).toLowerCase().trim().indexOf('bundle') !== -1;
  }

  function getSelectedVariantIdFromForm(form) {
    if (!form) return '';
    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) return String(variantInput.value);

    var variantSelect = form.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) return String(variantSelect.value);

    return '';
  }

  function getVariantPropertiesMap(form) {
    var serializedMap = form.getAttribute('data-attribution-variant-properties');
    var formComponent = form.closest && form.closest('product-form-component');
    if (!serializedMap && formComponent) {
      serializedMap = formComponent.getAttribute('data-attribution-variant-properties');
    }

    var parsedMap = safeJsonParse(serializedMap, null);
    if (parsedMap && typeof parsedMap === 'object' && !Array.isArray(parsedMap)) {
      return parsedMap;
    }

    return {};
  }

  function getConfigFromForm(form) {
    var config = {};
    var serializedConfig = form.getAttribute('data-attribution-line-properties');
    var formComponent = form.closest && form.closest('product-form-component');
    if (!serializedConfig && formComponent) {
      serializedConfig = formComponent.getAttribute('data-attribution-line-properties');
    }
    var parsedConfig = safeJsonParse(serializedConfig, null);
    if (parsedConfig && typeof parsedConfig === 'object' && !Array.isArray(parsedConfig)) {
      config = parsedConfig;
    }
    return config;
  }

  function parseMoneyToNumber(value) {
    if (!value) return NaN;
    var normalized = String(value).replace(/[^0-9.]/g, '');
    return normalized ? parseFloat(normalized) : NaN;
  }

  /**
   * @param {string | null | undefined} id
   * @returns {string}
   */
  function normalizeShopifyId(id) {
    if (!id) return '';
    var match = String(id).match(/(\d+)$/);
    return match ? match[1] : String(id);
  }

  /**
   * @param {HTMLFormElement} form
   * @returns {Element | null}
   */
  function getProductCardForForm(form) {
    if (!form) return null;

    var productCard = form.closest && form.closest('product-card');
    if (productCard) return productCard;

    var formComponent = form.closest && form.closest('product-form-component');
    if (!formComponent) return null;

    var productId = formComponent.getAttribute('data-product-id');
    if (!productId) return null;

    return document.querySelector('product-card[data-product-id="' + productId + '"]');
  }

  /**
   * @param {HTMLFormElement} form
   * @param {Element | null} productCard
   * @returns {string[]}
   */
  function getIomCollectionIdsForForm(form, productCard) {
    var collectionIds = [];
    var formComponent = form && form.closest && form.closest('product-form-component');

    function addCollectionId(id) {
      var normalized = normalizeShopifyId(id);
      if (!normalized) return;
      if (collectionIds.indexOf(normalized) === -1) {
        collectionIds.push(normalized);
      }
    }

    if (formComponent) {
      var fromFormComponent = (formComponent.getAttribute('data-iom-collections') || '')
        .split(',')
        .filter(Boolean);
      for (var i = 0; i < fromFormComponent.length; i++) {
        addCollectionId(fromFormComponent[i]);
      }
    }

    if (productCard) {
      var fromProductCard = (productCard.getAttribute('data-iom-collections') || '')
        .split(',')
        .filter(Boolean);
      for (var j = 0; j < fromProductCard.length; j++) {
        addCollectionId(fromProductCard[j]);
      }
    }

    var win = /** @type {any} */ (window);
    var productId = getProductIdFromForm(form);
    var fromMap = win.IOM_DATA?.product_collections_map?.[productId] ??
      win.IOM_DATA?.product_collections_map?.['gid://shopify/Product/' + productId] ??
      [];
    if (Array.isArray(fromMap)) {
      for (var k = 0; k < fromMap.length; k++) {
        addCollectionId(fromMap[k]);
      }
    }

    return collectionIds;
  }

  /**
   * @returns {any[]}
   */
  function getLineItemDiscountsFromIOM() {
    var win = /** @type {any} */ (window);
    var data = win.IOM_DATA;
    var iom = win.IOM;
    var catalog = (iom && typeof iom.offers === 'function' ? iom.offers() : null) ?? data?.offers ?? [];
    if (!Array.isArray(catalog) || !catalog.length) return [];

    var active = iom && typeof iom.getActiveOffers === 'function' ? iom.getActiveOffers() : [];
    var activeIds = new Set(active.map(function (offer) {
      return String(offer.id);
    }));

    var scoped =
      activeIds.size > 0
        ? catalog.filter(function (offer) {
            return activeIds.has(String(offer.id));
          })
        : catalog;

    return scoped.flatMap(function (offer) {
      return (offer.discounts || []).filter(function (discount) {
        return discount.discount_type === 'line_item';
      });
    });
  }

  /**
   * @param {string} productId
   * @param {string} variantId
   * @param {string[]} collectionIds
   * @param {number} basePriceDollars
   * @returns {string}
   */
  function calculateIomOneTimePurchasePrice(productId, variantId, collectionIds, basePriceDollars) {
    if (!productId || isNaN(basePriceDollars) || basePriceDollars <= 0) return '';

    var lineItemDiscounts = getLineItemDiscountsFromIOM();
    if (!lineItemDiscounts.length) return '';

    var productGid = 'gid://shopify/Product/' + normalizeShopifyId(productId);
    var variantGid = variantId ? 'gid://shopify/ProductVariant/' + normalizeShopifyId(variantId) : '';
    var collectionGids = collectionIds.map(function (id) {
      return 'gid://shopify/Collection/' + normalizeShopifyId(id);
    });

    var bestSavings = 0;
    for (var i = 0; i < lineItemDiscounts.length; i++) {
      var discount = lineItemDiscounts[i];
      var selection = discount.selection_type;
      var matches = false;

      if (selection === 'products') {
        matches =
          (variantGid &&
            (discount.variant_ids || []).some(function (id) {
              return normalizeShopifyId(id) === normalizeShopifyId(variantGid);
            })) ||
          (discount.product_ids || []).some(function (id) {
            return normalizeShopifyId(id) === normalizeShopifyId(productGid);
          });
      } else if (selection === 'collections') {
        matches = (discount.collection_ids || []).some(function (collectionId) {
          return collectionGids.some(function (gid) {
            return normalizeShopifyId(gid) === normalizeShopifyId(collectionId);
          });
        });
      } else if (selection === 'all') {
        matches = true;
      }

      if (!matches) continue;

      var valueType = discount.value_type;
      if (valueType !== 'percentage' && valueType !== 'fixed_amount') continue;

      var rawValue = Number(discount.value ?? discount.discount_value ?? 0);
      if (!rawValue) continue;

      var perProduct = discount.per_product_values?.[normalizeShopifyId(productGid)];
      var effectiveValue = perProduct != null ? Number(perProduct) : rawValue;
      var savings =
        valueType === 'percentage'
          ? basePriceDollars * (effectiveValue / 100)
          : valueType === 'fixed_amount'
            ? effectiveValue
            : 0;

      if (savings > bestSavings) bestSavings = savings;
    }

    if (bestSavings <= 0) return '';

    var discountedPrice = Math.max(0, basePriceDollars - bestSavings);
    if (discountedPrice >= basePriceDollars - 0.001) return '';

    return discountedPrice.toFixed(2);
  }

  /**
   * Resolves the single best IOM line-item discount for a product, including the
   * discount type/value so callers can render an accurate "Save" badge.
   *
   * Mirrors the matching logic of calculateIomOneTimePurchasePrice but returns the
   * winning discount's detail rather than only the final price string.
   *
   * @param {string} productId
   * @param {string} variantId
   * @param {string[]} collectionIds
   * @param {number} basePriceDollars
   * @returns {{discountedPrice: number, savings: number, valueType: string, value: number} | null}
   */
  function resolveBestIomDiscountDetail(productId, variantId, collectionIds, basePriceDollars) {
    if (!productId || isNaN(basePriceDollars) || basePriceDollars <= 0) return null;

    var lineItemDiscounts = getLineItemDiscountsFromIOM();
    if (!lineItemDiscounts.length) return null;

    var productGid = 'gid://shopify/Product/' + normalizeShopifyId(productId);
    var variantGid = variantId ? 'gid://shopify/ProductVariant/' + normalizeShopifyId(variantId) : '';
    var collectionGids = (collectionIds || []).map(function (id) {
      return 'gid://shopify/Collection/' + normalizeShopifyId(id);
    });

    var best = null;
    for (var i = 0; i < lineItemDiscounts.length; i++) {
      var discount = lineItemDiscounts[i];
      var selection = discount.selection_type;
      var matches = false;

      if (selection === 'products') {
        matches =
          (variantGid &&
            (discount.variant_ids || []).some(function (id) {
              return normalizeShopifyId(id) === normalizeShopifyId(variantGid);
            })) ||
          (discount.product_ids || []).some(function (id) {
            return normalizeShopifyId(id) === normalizeShopifyId(productGid);
          });
      } else if (selection === 'collections') {
        matches = (discount.collection_ids || []).some(function (collectionId) {
          return collectionGids.some(function (gid) {
            return normalizeShopifyId(gid) === normalizeShopifyId(collectionId);
          });
        });
      } else if (selection === 'all') {
        matches = true;
      }

      if (!matches) continue;

      var valueType = discount.value_type;
      if (valueType !== 'percentage' && valueType !== 'fixed_amount') continue;

      var rawValue = Number(discount.value != null ? discount.value : discount.discount_value || 0);
      if (!rawValue) continue;

      var perProduct = discount.per_product_values && discount.per_product_values[normalizeShopifyId(productGid)];
      var effectiveValue = perProduct != null ? Number(perProduct) : rawValue;
      var savings =
        valueType === 'percentage'
          ? basePriceDollars * (effectiveValue / 100)
          : valueType === 'fixed_amount'
            ? effectiveValue
            : 0;

      if (savings > 0 && (!best || savings > best.savings)) {
        best = { savings: savings, valueType: valueType, value: effectiveValue };
      }
    }

    if (!best || best.savings <= 0) return null;

    var discountedPrice = Math.max(0, basePriceDollars - best.savings);
    if (discountedPrice >= basePriceDollars - 0.001) return null;

    return {
      discountedPrice: discountedPrice,
      savings: best.savings,
      valueType: best.valueType,
      value: best.value,
    };
  }

  /**
   * Formats a dollar amount using IOM's configured money format (falls back to "$0.00").
   * @param {number} dollars
   * @returns {string}
   */
  function formatIomMoney(dollars) {
    var amount = Number(dollars);
    if (isNaN(amount)) return '';
    var fixed = amount.toFixed(2);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formattedAmount = parts.join('.');
    var win = /** @type {any} */ (window);
    var format = (win.IOM_DATA && win.IOM_DATA.money_format) || '${{amount}}';
    return format.replace(/\{\{\s*amount(?:_no_decimals|_with_comma_separator)?\s*\}\}/g, formattedAmount);
  }

  /**
   * Builds the "Save ..." badge text from IOM's badge template + the winning discount.
   * @param {{valueType: string, value: number, savings: number}} detail
   * @returns {string}
   */
  function buildIomBadgeText(detail) {
    var win = /** @type {any} */ (window);
    var template =
      (win.IOM_DATA && win.IOM_DATA.price_config && win.IOM_DATA.price_config.amount_template) || 'Save {discount}';
    var token =
      detail.valueType === 'percentage'
        ? Math.round(detail.value) + '%'
        : formatIomMoney(detail.savings);
    return template.replace(/\{discount\}/g, token);
  }

  /**
   * Decorates a single price span with IOM-style discount markup (strikethrough
   * original + discounted price + "Save" badge), matching what the IOM app injects
   * elsewhere on the site. Used for prices the IOM app cannot reach on its own
   * (for example the menu drawer, which is hidden at the app's initial scan).
   *
   * @param {Element} priceEl
   * @returns {boolean} Whether the element was decorated
   */
  function decorateIomPriceElement(priceEl) {
    if (!priceEl || !(priceEl instanceof HTMLElement)) return false;
    if (priceEl.getAttribute('data-aqt-iom-decorated') === '1') return false;
    if (priceEl.querySelector('.iom-price-overlay')) return false;

    var originalText = (priceEl.textContent || '').trim();
    // Skip ranged / volume pricing (e.g. "$10.00 - $20.00") to avoid mangling.
    if (/\d[\s\S]*[-–][\s\S]*\d/.test(originalText)) return false;

    var basePrice = parseMoneyToNumber(originalText);
    if (isNaN(basePrice) || basePrice <= 0) return false;

    var container = priceEl.closest('[data-product-id]');
    var productId = container ? container.getAttribute('data-product-id') : '';
    if (!productId) return false;

    var collectionIds = container
      ? (container.getAttribute('data-iom-collections') || '').split(',').filter(Boolean)
      : [];

    var detail = resolveBestIomDiscountDetail(productId, '', collectionIds, basePrice);
    if (!detail) return false;

    var discountedText = formatIomMoney(detail.discountedPrice);
    var badgeText = buildIomBadgeText(detail);

    var overlay = document.createElement('span');
    overlay.className = 'iom-price-overlay';

    var discountEl = document.createElement('span');
    discountEl.className = 'iom-discount-price';
    discountEl.textContent = discountedText;

    var originalEl = document.createElement('span');
    originalEl.className = 'iom-original-price';
    originalEl.textContent = originalText;

    var badgeEl = document.createElement('span');
    badgeEl.className = 'iom-discount-amount';
    badgeEl.textContent = badgeText;

    overlay.appendChild(discountEl);
    overlay.appendChild(originalEl);
    overlay.appendChild(badgeEl);

    priceEl.setAttribute('data-iom-original-price', originalText);
    priceEl.setAttribute('data-iom-original-price-text', originalText);
    priceEl.setAttribute('data-aqt-iom-decorated', '1');
    priceEl.textContent = '';
    priceEl.appendChild(overlay);

    return true;
  }

  /**
   * Decorates all eligible IOM price spans within a root element.
   * @param {Element | Document | null} root
   * @returns {number} Count of newly decorated elements
   */
  function decorateIomPrices(root) {
    var scope = root || document;
    var priceEls = scope.querySelectorAll('[data-product-type="price"]:not([data-aqt-iom-decorated="1"])');
    var count = 0;
    for (var i = 0; i < priceEls.length; i++) {
      if (decorateIomPriceElement(priceEls[i])) count++;
    }
    return count;
  }

  /**
   * Hooks IOM-style price decoration into the mobile menu drawer. The drawer is
   * hidden inside a closed <details> at page load, so the IOM app never scans it
   * and exposes no public re-scan API. When the drawer (or a submenu) opens we
   * decorate its product prices ourselves, retrying briefly to cover IOM's async
   * offer initialization.
   */
  function setupDrawerIomPriceDecoration() {
    if (document.documentElement.dataset.drawerIomDecorationBound === '1') return;
    document.documentElement.dataset.drawerIomDecorationBound = '1';

    function decorateDrawer(drawerRoot) {
      if (!drawerRoot) return;
      decorateIomPrices(drawerRoot);
      // IOM offers may not be resolved yet at the moment of opening; retry a few
      // times. decorateIomPrices is idempotent (decorated nodes are skipped).
      var delays = [200, 600, 1500];
      delays.forEach(function (delay) {
        setTimeout(function () {
          decorateIomPrices(drawerRoot);
        }, delay);
      });
    }

    // `toggle` does not bubble, so listen in the capture phase at the document.
    document.addEventListener(
      'toggle',
      function (event) {
        var target = event.target;
        if (!target || !(target instanceof Element) || !target.closest) return;
        if (target.tagName !== 'DETAILS' || !target.hasAttribute('open')) return;
        var drawerRoot = target.closest('header-drawer') || (target.closest('.menu-drawer') ? target : null);
        if (drawerRoot) decorateDrawer(drawerRoot);
      },
      true
    );
  }

  /**
   * Resolves the Shopify variant price in dollars for PLP quick-add comparisons.
   * @param {Element | null} productCard
   * @param {HTMLFormElement} form
   * @returns {number}
   */
  function getVariantShopifyPriceFromDom(productCard, form) {
    var formComponent = form && form.closest && form.closest('product-form-component');
    if (formComponent) {
      var priceCents = formComponent.getAttribute('data-variant-price');
      if (priceCents) {
        var parsedCents = parseInt(priceCents, 10);
        if (!isNaN(parsedCents)) return parsedCents / 100;
      }
    }

    if (productCard) {
      var variantScript = productCard.querySelector('variant-picker script[type="application/json"]');
      if (variantScript && variantScript.textContent) {
        try {
          var variant = JSON.parse(variantScript.textContent);
          if (variant && typeof variant.price === 'number') {
            return variant.price / 100;
          }
        } catch (error) {
          // fall through to other sources
        }
      }

      var originalPriceEl = productCard.querySelector(
        '.iom-original-price, .compare-at-price, .price-item--regular.compare-at-price'
      );
      if (originalPriceEl) {
        var originalAmount = parseMoneyToNumber(originalPriceEl.textContent);
        if (!isNaN(originalAmount)) return originalAmount;
      }
    }

    return NaN;
  }

  /**
   * Reads the IOM discounted price rendered on a product card.
   * @param {Element | null} productCard
   * @returns {number}
   */
  function getIomSalePriceFromProductCard(productCard) {
    if (!productCard) return NaN;

    var priceRoot = productCard.querySelector('product-price') || productCard;
    var discountEls = priceRoot.querySelectorAll('.iom-discount-price');
    for (var d = 0; d < discountEls.length; d++) {
      var discountAmount = parseMoneyToNumber(discountEls[d].textContent);
      if (!isNaN(discountAmount)) return discountAmount;
    }

    var priceEls = priceRoot.querySelectorAll('[data-product-type="price"]');
    for (var i = 0; i < priceEls.length; i++) {
      var priceEl = priceEls[i];
      if (priceEl.closest('.price__hidden')) continue;

      var overlayDiscount = priceEl.querySelector('.iom-discount-price');
      if (overlayDiscount) {
        var overlayAmount = parseMoneyToNumber(overlayDiscount.textContent);
        if (!isNaN(overlayAmount)) return overlayAmount;
      }

      if (priceEl.querySelector('.iom-price-overlay')) continue;

      var amount = parseMoneyToNumber(priceEl.textContent);
      if (!isNaN(amount)) return amount;
    }

    return NaN;
  }

  /**
   * Reads IOM sale price shown on product cards when it is lower than the variant's Shopify price.
   * @param {HTMLFormElement} form
   * @returns {string}
   */
  function getIomOneTimePurchasePriceFromDom(form) {
    if (!form) return '';

    var productCard = getProductCardForForm(form);
    var productId = getProductIdFromForm(form);
    var variantId = getSelectedVariantIdFromForm(form);
    var basePrice = getVariantShopifyPriceFromDom(productCard, form);
    if (isNaN(basePrice) || basePrice <= 0) return '';

    var saleAmount = getIomSalePriceFromProductCard(productCard);
    if (!isNaN(saleAmount) && saleAmount < basePrice - 0.001) {
      logDebug('IOM sale price from DOM overlay', saleAmount, 'base', basePrice);
      return saleAmount.toFixed(2);
    }

    var collectionIds = getIomCollectionIdsForForm(form, productCard);
    var fromOffers = calculateIomOneTimePurchasePrice(productId, variantId, collectionIds, basePrice);
    if (fromOffers) {
      logDebug('IOM sale price from offers API', fromOffers, 'base', basePrice);
      return fromOffers;
    }

    return '';
  }

  /**
   * Copies product/collection context onto the form so IOM and theme attribution resolve the same card.
   * @param {HTMLFormElement} form
   */
  function stampIomFormContext(form) {
    if (!form) return;

    var formComponent = form.closest && form.closest('product-form-component');
    var productCard = getProductCardForForm(form);
    var container = productCard || formComponent || form;

    var productId = normalizeShopifyId(getProductIdFromForm(form));
    var variantId = normalizeShopifyId(getSelectedVariantIdFromForm(form));
    var collectionIds = getIomCollectionIdsForForm(form, productCard);

    if (productId) {
      form.setAttribute('data-iom-product-id', productId);
      if (formComponent) formComponent.setAttribute('data-iom-product-id', productId);
    }

    if (variantId) {
      form.setAttribute('data-iom-variant-id', variantId);
      if (formComponent) formComponent.setAttribute('data-iom-variant-id', variantId);
    }

    if (collectionIds.length) {
      var collectionValue = collectionIds.join(',');
      form.setAttribute('data-iom-collections', collectionValue);
      if (container && container !== form) {
        container.setAttribute('data-iom-collections', collectionValue);
      }
    }
  }

  /**
   * @param {any} discount
   * @param {string} productId
   * @param {string} variantId
   * @param {string[]} collectionIds
   * @returns {boolean}
   */
  function iomDiscountMatchesProduct(discount, productId, variantId, collectionIds) {
    if (!discount) return false;

    var discountType = discount.discount_type;
    if (discountType !== 'line_item' && discountType !== 'tier_based') return false;

    var selection = discount.selection_type || 'products';
    if (selection === 'all') return true;

    var productIds = (discount.product_ids || []).map(normalizeShopifyId).filter(Boolean);
    var variantIds = (discount.variant_ids || []).map(normalizeShopifyId).filter(Boolean);
    var discountCollectionIds = (discount.collection_ids || []).map(normalizeShopifyId).filter(Boolean);

    if (productId && productIds.indexOf(productId) !== -1) return true;
    if (variantId && variantIds.indexOf(variantId) !== -1) return true;

    if (selection === 'collections' || discountCollectionIds.length) {
      for (var i = 0; i < collectionIds.length; i++) {
        if (discountCollectionIds.indexOf(collectionIds[i]) !== -1) return true;
      }
    }

    if (selection === 'products' && !productIds.length && !variantIds.length) {
      return true;
    }

    return false;
  }

  /**
   * @param {any} offer
   * @param {string} productId
   * @param {string} variantId
   * @param {string[]} collectionIds
   * @returns {boolean}
   */
  function iomOfferMatchesProduct(offer, productId, variantId, collectionIds) {
    var discounts = offer && offer.discounts;
    if (!Array.isArray(discounts)) return false;

    for (var i = 0; i < discounts.length; i++) {
      if (iomDiscountMatchesProduct(discounts[i], productId, variantId, collectionIds)) {
        return true;
      }
    }

    return false;
  }

  /**
   * @param {any} campaign
   * @param {string} offerId
   * @returns {boolean}
   */
  function iomCampaignIncludesOffer(campaign, offerId) {
    if (!campaign || !offerId) return false;

    var connected = campaign.connected_offers;
    if (!Array.isArray(connected) || !connected.length) return false;

    for (var i = 0; i < connected.length; i++) {
      if (String(connected[i].offer_id) === String(offerId)) return true;
    }

    return false;
  }

  /**
   * Builds IOM `_iom_line` cart properties with the correct product/collection context.
   * IOM's fetch interceptor uses page-level product id on collection PLPs, which breaks discounts.
   * @param {HTMLFormElement} form
   * @param {string} [variantIdOverride]
   * @returns {Record<string, string>}
   */
  function buildIomLineItemProperties(form, variantIdOverride) {
    var win = /** @type {any} */ (window);
    var iom = win.IOM;
    if (!iom || typeof iom.getActiveCampaigns !== 'function' || typeof iom.getActiveOffers !== 'function') {
      return {};
    }

    stampIomFormContext(form);

    var productId = normalizeShopifyId(getProductIdFromForm(form));
    var variantId = normalizeShopifyId(
      variantIdOverride ? String(variantIdOverride) : getSelectedVariantIdFromForm(form)
    );
    var productCard = getProductCardForForm(form);
    var collectionIds = getIomCollectionIdsForForm(form, productCard);

    if (!variantId) return {};

    var activeCampaigns = iom.getActiveCampaigns() || [];
    var activeOffers = iom.getActiveOffers() || [];
    if (!activeCampaigns.length || !activeOffers.length) return {};

    /** @type {Record<string, string[]>} */
    var campaignOfferMap = {};

    for (var c = 0; c < activeCampaigns.length; c++) {
      var campaign = activeCampaigns[c];
      var matchedOfferIds = [];

      for (var o = 0; o < activeOffers.length; o++) {
        var offer = activeOffers[o];
        if (!iomCampaignIncludesOffer(campaign, offer.id)) continue;
        if (!iomOfferMatchesProduct(offer, productId, variantId, collectionIds)) continue;
        if (matchedOfferIds.indexOf(String(offer.id)) === -1) {
          matchedOfferIds.push(String(offer.id));
        }
      }

      if (matchedOfferIds.length) {
        campaignOfferMap[String(campaign.id)] = matchedOfferIds;
      }
    }

    var campaignIds = Object.keys(campaignOfferMap);
    if (!campaignIds.length) return {};

    var offerIds = [];
    for (var ci = 0; ci < campaignIds.length; ci++) {
      var ids = campaignOfferMap[campaignIds[ci]] || [];
      for (var oi = 0; oi < ids.length; oi++) {
        if (offerIds.indexOf(ids[oi]) === -1) offerIds.push(ids[oi]);
      }
    }

    var properties = {
      _iom_line: JSON.stringify({
        campaigns: campaignIds,
        offers: offerIds,
        collections: collectionIds,
      }),
      _iom_offer_channel_name: 'Campaign',
      _iom_offer_from_landing_page: String(window.location.pathname.indexOf('/pages/') !== -1),
    };

    for (var k = 0; k < activeCampaigns.length; k++) {
      if (String(activeCampaigns[k].id) === campaignIds[0]) {
        properties._iom_offer_campaign_name = String(activeCampaigns[k].name || activeCampaigns[k].campaignName || '');
        break;
      }
    }

    try {
      var utmPriorityCampaign = win.localStorage && win.localStorage.getItem('iom_utm_priority_campaign');
      if (utmPriorityCampaign && campaignIds.indexOf(normalizeShopifyId(utmPriorityCampaign)) !== -1) {
        properties._iom_utm_priority = 'true';
      }
    } catch (error) {
      // ignore storage access errors
    }

    logDebug('Built IOM line properties', properties, {
      productId: productId,
      variantId: variantId,
      collectionIds: collectionIds,
    });

    return properties;
  }

  function buildLineItemProperties(form, variantIdOverride) {
    var properties = {};
    var config = getConfigFromForm(form);
    var variantId = variantIdOverride ? String(variantIdOverride) : getSelectedVariantIdFromForm(form);
    var variantMap = getVariantPropertiesMap(form);
    var variantScopedConfig = variantMap[variantId];

    if (variantScopedConfig && typeof variantScopedConfig === 'object' && !Array.isArray(variantScopedConfig)) {
      for (var key in variantScopedConfig) {
        if (Object.prototype.hasOwnProperty.call(variantScopedConfig, key)) {
          config[key] = variantScopedConfig[key];
        }
      }
    }

    var sku = typeof config._variant_sku === 'string' ? config._variant_sku : getVariantSkuFromForm(form);
    if (sku) {
      properties._variant_sku = String(sku);
    }

    var productId = getProductIdFromForm(form);
    if (productId) {
      properties._product_id = String(productId);
    }

    var optionalPropertyKeys = [
      '_isbundle',
      '_lot_number',
      '_bundle_quantity',
      '_warehouse',
      '_one_time_purchase_price',
      '_upsell',
    ];

    for (var i = 0; i < optionalPropertyKeys.length; i++) {
      var propertyKey = optionalPropertyKeys[i];
      var value = config[propertyKey];

      if (value === undefined || value === null || value === '') {
        continue;
      }

      properties[propertyKey] = String(value);
    }

    if (isBundleProductType(getProductTypeFromForm(form))) {
      if (!properties._isbundle) {
        properties._isbundle = 'true';
      }

      if (!properties._bundle_quantity) {
        properties._bundle_quantity =
          config._bundle_quantity !== undefined && config._bundle_quantity !== null && config._bundle_quantity !== ''
            ? String(config._bundle_quantity)
            : '1';
      }
    }

    if (!properties._one_time_purchase_price) {
      var iomSalePrice = getIomOneTimePurchasePriceFromDom(form);
      if (iomSalePrice) {
        properties._one_time_purchase_price = iomSalePrice;
      }
    }

    var iomLineProperties = buildIomLineItemProperties(form, variantId);
    for (var iomKey in iomLineProperties) {
      if (Object.prototype.hasOwnProperty.call(iomLineProperties, iomKey)) {
        properties[iomKey] = iomLineProperties[iomKey];
      }
    }

    return properties;
  }

  function attachLineItemProperties(form) {
    var properties = buildLineItemProperties(form);
    for (var key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key)) {
        setHiddenInput(form, 'properties[' + key + ']', properties[key]);
      }
    }
  }

  function isAddToCartForm(form) {
    if (!form || !form.matches) return false;
    if (form.getAttribute('data-type') === 'add-to-cart-form') return true;
    if (/\/cart\/add(\.js)?($|\?)/.test(form.getAttribute('action') || '')) return true;
    return false;
  }

  function bindProductFormHooks(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (!isAddToCartForm(form) || form.dataset.attributionBound === '1') continue;
      form.dataset.attributionBound = '1';

      form.addEventListener('submit', function (event) {
        attachLineItemProperties(event.currentTarget);
      });
    }
  }

  function doSyncCartAttributes(extraAttributes) {
    var attributes = buildCartAttributesPayload();
    if (extraAttributes && typeof extraAttributes === 'object') {
      for (var key in extraAttributes) {
        if (Object.prototype.hasOwnProperty.call(extraAttributes, key)) {
          attributes[key] = extraAttributes[key];
        }
      }
    }

    return fetch(buildThemePath('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart attribute sync failed with status ' + response.status);
      }
      return response.json();
    });
  }

  function syncCartAttributes(extraAttributes) {
    if (_eftidResolved || resolveEftid()) {
      return doSyncCartAttributes(extraAttributes);
    }
    return new Promise(function (resolve, reject) {
      var waited = 0;
      var checkInterval = setInterval(function () {
        waited += 100;
        var tid = getEftidFromSdk() || getEftidFromCookie();
        if (tid) {
          clearInterval(checkInterval);
          storeEftid(tid);
          doSyncCartAttributes(extraAttributes).then(resolve, reject);
        } else if (waited >= 3000) {
          clearInterval(checkInterval);
          logDebug('eftid not available after 3s wait, syncing without it');
          doSyncCartAttributes(extraAttributes).then(resolve, reject);
        }
      }, 100);
    });
  }

  function storeEftid(tid) {
    _eftidResolved = true;
    var stored = getStoredAttribution();
    if (stored.eftid === tid) return;
    stored.eftid = tid;
    setStoredAttribution(stored);
    logDebug('Everflow eftid captured:', tid);
    syncCartAttributes().catch(function () {});
  }

  function pollEverflowTransactionId() {
    var tid = getEftidFromSdk();
    if (tid) {
      storeEftid(tid);
      return;
    }
    var attempts = 0;
    var maxAttempts = 150;
    var interval = setInterval(function () {
      attempts++;
      tid = getEftidFromSdk() || getEftidFromCookie();
      if (tid) {
        clearInterval(interval);
        storeEftid(tid);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        logDebug('Everflow SDK polling exhausted after 30s, no eftid found');
      }
    }, 200);
  }

  function decorateCheckoutLinks(root) {
    var scope = root || document;

    var checkoutAnchors = scope.querySelectorAll('a[href*="/checkout"]');
    for (var i = 0; i < checkoutAnchors.length; i++) {
      var anchor = checkoutAnchors[i];
      var href = anchor.getAttribute('href');
      if (isEligibleCheckoutAnchor(href)) {
        anchor.setAttribute('href', appendMarketingParamsToUrl(href));
      }
    }

    var checkoutButtons = scope.querySelectorAll('button[name="checkout"], input[name="checkout"]');
    for (var j = 0; j < checkoutButtons.length; j++) {
      var button = checkoutButtons[j];
      if (button.dataset.checkoutAttributionBound === '1') continue;
      button.dataset.checkoutAttributionBound = '1';

      button.addEventListener('click', function (event) {
        var target = event.currentTarget;
        var form = target && target.form;
        if (!form) return;
        var checkoutUrl = getCheckoutSubmitUrl(form, target);
        target.setAttribute('formaction', appendMarketingParamsToUrl(checkoutUrl));
      });
    }
  }

  function bindCheckoutDelegates() {
    if (document.documentElement.dataset.checkoutAttributionDelegateBound === '1') return;
    document.documentElement.dataset.checkoutAttributionDelegateBound = '1';

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var checkoutTrigger = target.closest('button[name="checkout"], input[name="checkout"]');
        if (checkoutTrigger && checkoutTrigger.form) {
          var submitUrl = getCheckoutSubmitUrl(checkoutTrigger.form, checkoutTrigger);
          checkoutTrigger.setAttribute('formaction', appendMarketingParamsToUrl(submitUrl));
          return;
        }

        var checkoutAnchor = target.closest('a[href*="/checkout"]');
        if (checkoutAnchor) {
          var href = checkoutAnchor.getAttribute('href');
          if (isEligibleCheckoutAnchor(href)) {
            checkoutAnchor.setAttribute('href', appendMarketingParamsToUrl(href));
          }
        }
      },
      true
    );
  }

  // Line keys with an in-flight strip request, so overlapping scans don't fire
  // redundant change.js calls for the same line.
  var eliteCartStripInFlight = {};

  /**
   * Strips IOM-injected line properties (`_iom_line`, `_iom_offer_*`) from a
   * single cart line, preserving everything else (e.g. EliteCart tracking
   * props). Returns the change.js request promise.
   * @param {any} item Shopify cart line object from /cart.js
   * @returns {Promise<any>}
   */
  function stripIomPropertiesFromLine(item) {
    if (eliteCartStripInFlight[item.key]) return Promise.resolve(null);
    eliteCartStripInFlight[item.key] = true;

    var cleanProperties = {};
    var properties = item.properties || {};
    for (var key in properties) {
      if (!Object.prototype.hasOwnProperty.call(properties, key)) continue;
      if (key.indexOf('_iom') === 0) continue;
      cleanProperties[key] = properties[key];
    }

    logDebug('Stripping injected IOM props from free EliteCart upsell line', item.key);

    function clearInFlight(value) {
      delete eliteCartStripInFlight[item.key];
      return value;
    }

    return fetch(buildThemePath('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: item.key, properties: cleanProperties }),
    }).then(function (response) {
      return response.json().then(function (cart) {
        return clearInFlight(cart);
      });
    }, function (error) {
      clearInFlight();
      throw error;
    });
  }

  /**
   * EliteCart upsell adds bypass the theme's add-to-cart forms, so IOM's own
   * fetch interceptor stamps `_iom_line` on them using the *current page*
   * product context. On a product page whose product belongs to a fixed-amount
   * discount collection, that wrong context can momentarily zero-out a cheap
   * upsell line until IOM's async repair runs ~2s later — long enough for a
   * shopper to reach checkout for free. We close that window: when an EliteCart
   * upsell line is found priced at $0 (while its product is not actually free),
   * strip the injected IOM properties so the line falls back to its own
   * (EliteCart) discount instead of the mis-applied collection discount.
   * @returns {Promise<any>}
   */
  function repairFreeEliteCartUpsellLines() {
    return fetch(buildThemePath('cart.js'), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var repairs = [];
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          var properties = item.properties || {};
          var isEliteCartUpsell = !!(properties.__eliteCartUpsell || properties.__eliteCartUpsellAtt);
          var hasInjectedIom = !!properties._iom_line;
          var isImplausiblyFree = item.final_price === 0 && item.original_price > 0;
          if (isEliteCartUpsell && hasInjectedIom && isImplausiblyFree) {
            repairs.push(stripIomPropertiesFromLine(item));
          }
        }
        return Promise.all(repairs);
      })
      .catch(function () {
        // Never block the cart on a repair failure.
      });
  }

  /**
   * @param {string} url
   * @returns {boolean}
   */
  function isEliteCartUpsellAddUrl(url) {
    var value = String(url || '');
    if (!/\/cart\/add(\.js)?/.test(value)) return false;
    return /elitecart=/.test(value);
  }

  // A fetch reference taken from a hidden same-origin iframe. Because it is the
  // iframe window's own fetch, it bypasses IOM's top-window fetch wrapper, so
  // requests sent through it are NOT stamped with a page-context `_iom_line`.
  var pristineFetchRef = null;
  function getPristineFetch() {
    if (pristineFetchRef) return pristineFetchRef;
    try {
      var host = document.body || document.documentElement;
      if (!host) return null;
      var iframe = document.createElement('iframe');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('tabindex', '-1');
      iframe.style.display = 'none';
      host.appendChild(iframe);
      var frameWindow = iframe.contentWindow;
      if (frameWindow && typeof frameWindow.fetch === 'function') {
        pristineFetchRef = frameWindow.fetch.bind(frameWindow);
      }
    } catch (error) {
      pristineFetchRef = null;
    }
    return pristineFetchRef;
  }

  /**
   * Returns a copy of a line-item properties object with all IOM-injected keys
   * (`_iom_line`, `_iom_offer_*`) removed; other props are preserved.
   * @param {Object} props
   * @returns {Object}
   */
  function stripIomFromPropertiesObject(props) {
    if (!props || typeof props !== 'object') return props;
    var out = {};
    for (var key in props) {
      if (!Object.prototype.hasOwnProperty.call(props, key)) continue;
      if (key.indexOf('_iom') === 0) continue;
      out[key] = props[key];
    }
    return out;
  }

  /**
   * Inspects a /cart/add.js or /cart/change.js request. If it is an EliteCart
   * upsell write (its line properties carry `__eliteCartUpsell`), returns a
   * serialized body with any `_iom_*` props stripped so the line keeps its own
   * EliteCart discount instead of the mis-applied page-context IOM discount.
   * Returns null for non-upsell or unparseable requests (handle normally).
   * @param {string} url
   * @param {RequestInit|undefined} init
   * @returns {{ cleanBody: string }|null}
   */
  function inspectEliteCartUpsellWrite(url, init) {
    if (!/\/cart\/(add|change)(\.js)?/.test(String(url || ''))) return null;
    var body = init && init.body;
    if (typeof body !== 'string') return null;

    var parsed;
    try {
      parsed = JSON.parse(body);
    } catch (error) {
      return null;
    }

    var hasUpsell = false;
    if (parsed && parsed.properties) {
      if (parsed.properties.__eliteCartUpsell || parsed.properties.__eliteCartUpsellAtt) hasUpsell = true;
      parsed.properties = stripIomFromPropertiesObject(parsed.properties);
    }
    if (parsed && parsed.items && parsed.items.length) {
      for (var i = 0; i < parsed.items.length; i++) {
        var item = parsed.items[i];
        var itemProps = item && item.properties;
        if (itemProps && (itemProps.__eliteCartUpsell || itemProps.__eliteCartUpsellAtt)) hasUpsell = true;
        if (itemProps) parsed.items[i].properties = stripIomFromPropertiesObject(itemProps);
      }
    }

    if (!hasUpsell) return null;
    return { cleanBody: JSON.stringify(parsed) };
  }

  /**
   * Runs the free-upsell-line repair on a short cadence. The mis-stamped line
   * lands in the cart within ~150ms, but the EliteCart add request's promise
   * can resolve up to ~2s later (IOM wraps fetch and defers resolution). We
   * therefore scan eagerly from the moment the add is detected — independent of
   * when its promise resolves — so the $0 line is corrected well before a
   * shopper can reach checkout.
   */
  function scheduleEliteCartUpsellRepair() {
    var delays = [150, 350, 600, 1000, 1500, 2500];
    for (var i = 0; i < delays.length; i++) {
      setTimeout(repairFreeEliteCartUpsellLines, delays[i]);
    }
  }

  /**
   * Wraps window.fetch once to detect EliteCart upsell adds and run the
   * free-line repair across a few async ticks (IOM stamps/repairs on a delay).
   */
  function setupEliteCartUpsellGuard() {
    if (document.documentElement.dataset.eliteCartUpsellGuardBound === '1') return;
    if (typeof window.fetch !== 'function') return;
    document.documentElement.dataset.eliteCartUpsellGuardBound = '1';

    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';

      // Deterministic fix: EliteCart upsell cart-writes (add/change carrying
      // `__eliteCartUpsell`) must not flow through IOM's fetch wrapper, which
      // stamps a page-context `_iom_line` (incl. the $100 collection) and zeroes
      // the upsell. Re-route them through a pristine iframe fetch with `_iom_*`
      // stripped, so the line is born — and stays — at its own EliteCart price.
      var upsellWrite = typeof input === 'string' ? inspectEliteCartUpsellWrite(url, init) : null;
      var pristineFetch = upsellWrite ? getPristineFetch() : null;
      if (upsellWrite && pristineFetch) {
        var rerouteInit = {};
        if (init) {
          for (var initKey in init) {
            if (Object.prototype.hasOwnProperty.call(init, initKey)) rerouteInit[initKey] = init[initKey];
          }
        }
        rerouteInit.body = upsellWrite.cleanBody;
        if (!rerouteInit.credentials) rerouteInit.credentials = 'same-origin';

        var reroutedResult = pristineFetch(input, rerouteInit);
        scheduleEliteCartUpsellRepair();
        return reroutedResult;
      }

      var result = nativeFetch(input, init);

      if (isEliteCartUpsellAddUrl(url)) {
        scheduleEliteCartUpsellRepair();
        result
          .then(function () {
            repairFreeEliteCartUpsellLines();
          })
          .catch(function () {});
      }

      return result;
    };
  }

  function init(options) {
    if (options && options.debug === true) safeStorageSet(DEBUG_KEY, '1');
    if (options && options.debug === false) safeStorageSet(DEBUG_KEY, '0');

    captureFromCurrentUrl();
    pollEverflowTransactionId();
    bindProductFormHooks(document);
    decorateCheckoutLinks(document);
    bindCheckoutDelegates();
    setupDrawerIomPriceDecoration();
    setupEliteCartUpsellGuard();
  }

  window.Attribution = {
    init: init,
    captureFromCurrentUrl: captureFromCurrentUrl,
    getAttribution: getAttribution,
    buildCartAttributesPayload: buildCartAttributesPayload,
    appendMarketingParamsToUrl: appendMarketingParamsToUrl,
    bindProductFormHooks: bindProductFormHooks,
    attachLineItemProperties: attachLineItemProperties,
    buildLineItemProperties: buildLineItemProperties,
    buildIomLineItemProperties: buildIomLineItemProperties,
    stampIomFormContext: stampIomFormContext,
    syncCartAttributes: syncCartAttributes,
    decorateCheckoutLinks: decorateCheckoutLinks,
    bindCheckoutDelegates: bindCheckoutDelegates,
    decorateIomPrices: decorateIomPrices,
    setupEliteCartUpsellGuard: setupEliteCartUpsellGuard,
    repairFreeEliteCartUpsellLines: repairFreeEliteCartUpsellLines,
    enableDebug: function () {
      safeStorageSet(DEBUG_KEY, '1');
    },
    disableDebug: function () {
      safeStorageSet(DEBUG_KEY, '0');
    },
  };
  // Backward-compatible alias
  window.AQTAttribution = window.Attribution;
})();
